
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["handleConferenceView","handleRankingData","handlePlayerLeaderboard","getStatHubSeoStats","getReceivingHubSeoStats","handleTeamDetailView","getRankingData","applyDraftClassFilter","applyDraftRoundFilter","applyPositionFilter","applyDataFilters","handleStatFilter"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "349d625fb052f8b0a7f3.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "349d625fb052f8b0a7f3.worker.js");
					addMethods(w, methods)
					
					return w
				}
			